import { TIMERECORDING_TYPE_OF_WORK_CODES } from '../models/complex/time-recording-entry.model';
import { TimesheetEntryInterface } from '../models/complex/timesheet-entry.interface';
import { TimesheetEntryModel } from '../models/complex/timesheet-entry.model';
import { TimesheetEowModel } from '../models/complex/timesheet-eow.model';
import { TimesheetGapModel } from '../models/complex/timesheet-gap.model';
import { TimesheetManualEntryModel } from '../models/complex/timesheet-manual-entry.model';
import { TimesheetSowModel } from '../models/complex/timesheet-sow.model';

/**
 * Pure type-guard helpers for the different kinds of timesheet entries. Extracted from
 * TimesheetAndExpensesService so they can be reused without depending on the service.
 */

// type guard function for TimesheetGapModel
export function isGapEntry(entry: TimesheetEntryInterface): entry is TimesheetGapModel {
    return entry instanceof TimesheetGapModel;
}

// type guard function for TimesheetManualEntryModel
export function isManualEntry(entry: TimesheetEntryInterface): entry is TimesheetManualEntryModel {
    return entry instanceof TimesheetManualEntryModel;
}

// type guard function for TimesheetEntryModel
export function isNormalEntry(entry: TimesheetEntryInterface): entry is TimesheetEntryModel {
    return entry instanceof TimesheetEntryModel;
}

// type guard function for TimesheetSoWModel
export function isSowEntry(entry: TimesheetEntryInterface): entry is TimesheetSowModel {
    return entry instanceof TimesheetSowModel;
}

// type guard function for TimesheetEoWModel
export function isEowEntry(entry: TimesheetEntryInterface): entry is TimesheetEowModel {
    return entry instanceof TimesheetEowModel;
}

export function isTravelBackEntry(entry: TimesheetEntryInterface): boolean {
    return (
        entry instanceof TimesheetEntryModel &&
        (entry.workCode.value === TIMERECORDING_TYPE_OF_WORK_CODES.TRBK ||
            entry.workCode.value === TIMERECORDING_TYPE_OF_WORK_CODES.TRAVEL_BACK_STANDBY)
    );
}

export function isTravelToEntry(entry: TimesheetEntryInterface): boolean {
    return (
        entry instanceof TimesheetEntryModel &&
        (entry.workCode.value === TIMERECORDING_TYPE_OF_WORK_CODES.TRTO ||
            entry.workCode.value === TIMERECORDING_TYPE_OF_WORK_CODES.TRAVEL_TO_STANDBY)
    );
}
